<template>
  <div>
    <transition
      mode="out-in"
      :name="animate"
    >
      <keep-alive :include="keepAliveRoutes">
        <router-view v-if="!loading" />
      </keep-alive>
    </transition>
    <div
      v-if="loading"
      class="loading-box"
      :style="{ height: $vw(pageHeight) }"
    >
      <!-- 动画 -->
      <via-lottie
        :animation-data="animationData"
        :height="pageHeight * 0.8"
        :width="375 * 0.8"
        :animation-speed="0.8"
      />
    </div>
    <!-- tabbar blank -->
    <div class="tabbar-blank" />
    <!-- tabbar -->
    <van-tabbar
      v-model="tabbar.active"
      :border="false"
      fixed
      :z-index="99"
      safe-area-inset-bottom
      @change="switchTo"
    >
      <van-tabbar-item
        v-for="(item,index) in tabbar.items"
        :key="item.icon"
        :style="{color:tabbar.active == index ? tabbar.activeColor : tabbar.inactiveColor}"
      >
        <span>{{ item.title }}</span>
        <via-star
          slot="icon"
          :width="375 / tabbar.items.length"
          :height="25"
          size="25px"
          :icon="item.icon"
          :color="tabbar.active == index ? tabbar.activeColor : tabbar.inactiveColor"
        />
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import ViaLottie from 'components/common/via-lottie'
import * as animationData from 'static/lottie/lottie-app.json'
import { Tabbar, TabbarItem } from 'vant'

export default {
  name: 'TabBar',
  components: {
    [ViaLottie.name]: ViaLottie,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem
  },
  data() {
    return {
      animate: 'slide-left',
      tabbar: {
        active: 0,
        activeColor: 'var(--themeColor)',
        inactiveColor: 'var(--light60)',
        items: [
          {
            title: '首页',
            icon: 'androidlist',
            to: {
              name: 'Home'
            }
          },
          {
            title: '插件',
            icon: 'extension',
            to: {
              name: 'Plugin'
            }
          },
          {
            title: '其他',
            icon: 'filing',
            to: {
              name: 'Other'
            }
          },
          {
            title: '关于',
            icon: 'informationcircled',
            to: {
              name: 'About'
            }
          }
        ]
      },
      animationData: animationData.default,
      loading: false
    }
  },
  computed: {
    // rpx
    pageHeight() {
      const tabbarHeight = 60
      const defaultHeight = this.$pxToRpx(this.$clientHeight)
      return defaultHeight - tabbarHeight
    },
    keepAliveRoutes() {
      const routes = this.$router.options.routes
      const routeNames = this.getRouteNameArr(routes)
      return routeNames
    }
  },
  watch: {
    '$route'(to, from) {
      const parentFrom = from.matched.length >= 2 ? from.matched[from.matched.length - 2] : null
      const parentTo = to.matched.length >= 2 ? to.matched[to.matched.length - 2] : null
      if (parentFrom && parentTo && parentFrom.name === parentTo.name) {
        const fromIndex = from.meta && from.meta.index
        const toIndex = to.meta && to.meta.index
        if (fromIndex && toIndex) {
          if (fromIndex < toIndex) {
            this.animate = 'slide-left'
          }
          if (fromIndex > toIndex) {
            this.animate = 'slide-right'
          }
        } else {
          console.error('请到route处meta添加index')
          this.animate = 'fade'
        }
      } else {
        this.animate = 'fade'
      }
    }
  },
  mounted() {
    // active匹配路由
    for (let i = 0; i < this.tabbar.items.length; i++) {
      if (this.tabbar.items[i].to && this.tabbar.items[i].to.name === this.$route.name) {
        this.$set(this.tabbar, 'active', i)
      }
    }

    // 获取首页配置并存到vuex
    this.loading = true
    this.$api.home.findLatest().then(res => {
      const homeConfig = res.data
      this.$store.commit('home/updateHomeConfig', homeConfig)
      setTimeout(() => {
        this.loading = false
      }, 1000)
    })
  },
  methods: {
    // 获取缓存的路由名字列表
    getRouteNameArr(routes) {
      let routeNameArr = []
      for (let i = 0; i < routes.length; i++) {
        const route = routes[i]
        if (route.meta && route.meta.keepAlive) {
          routeNameArr.push(route.name)
        }
        if (route.children) {
          routeNameArr = routeNameArr.concat(this.getRouteNameArr(route.children))
        }
      }
      return routeNameArr
    },
    switchTo(activeIndex) {
      this.$router.$replace(this.tabbar.items[activeIndex].to)
    }
  }
}
</script>

<style scoped>
.tabbar-blank {
    width: 375px;
    height: 60px;
}
.loading-box {
    display: flex;
    justify-content: center;
    align-items: center;
}
.slide-left-enter-active {
    animation: fadeInRight .1s forwards;
}

.slide-left-leave-active {
    animation: fadeOutLeft .2s forwards;
}
 .slide-right-enter-active {
    animation: fadeInLeft .1s forwards;
}

.slide-right-leave-active {
    animation: fadeOutRight .2s forwards;
}
.fade-enter-active, .fade-leave-active {
    transition: opacity .2s;
}
.fade-enter, .fade-leave-to {
    opacity: 0;
}
</style>
